const items = [
  "Compression",
  "Halo Therapy",
  "Red Light",
  "Cold Plunge",
  "Sauna",
  "PEMF",
  "HBOT",
  "Salt Float"
];

export const Marquee = () => (
  <section aria-hidden="true" className="overflow-hidden border-y border-white/10 py-8" data-testid="modality-marquee">
    <div className="flex w-max animate-marquee whitespace-nowrap">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center">
          {items.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="px-8 font-display text-4xl font-black uppercase tracking-tighter text-outline md:text-6xl">
                {item}
              </span>
              <span className="h-2 w-2 rounded-full bg-rest-red/70" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
